// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6663":"27d62d13","8523":"1d63bc9e","8639":"fb0d133c"}[chunkId] + ".chunk.css";
};